const translations = {
  "en": {
    "Checking sector concentration": "Connecting dots others would miss",
    "Connected to Schwab": "Seeing where you really stand",
    "Drafting your guardrail plan": "Shaping the moves that matter",
    "Read your positions": "Tracing the leaks across your money"
  },
  "zh-tw": {
    "Checking sector concentration": "串連起他人會錯過的線索",
    "Connected to Schwab": "看清你真正的財務狀況",
    "Drafting your guardrail plan": "為你規劃真正重要的下一步",
    "Read your positions": "逐一追蹤你資金的漏洞"
  }
};

export default translations;
